module.exports = __webpack_public_path__ + "posture/static/img/head_sideway_left.cbed27d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/head_sideway_left.png
// module id = WxYu
// module chunks = 1